import { FC } from 'react';
import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
import type { SVGProps } from 'react';
import { cn } from '@fe-learner-common';

export type FaIconProps = SVGProps<SVGSVGElement> & {
  icon: IconDefinition;
  height?: number | string;
  width?: number | string;
  className?: string;
  rtlSupport?: boolean;
};

const xmlns = 'http://www.w3.org/2000/svg';

export const FaIcon: FC<FaIconProps> = ({
  icon: iconProps,
  className,
  children,
  height = 16,
  width,
  rtlSupport = false,
  ...rest
}) => {
  const { prefix, iconName, icon } = iconProps;
  const [iconWidth, iconHeight, , , svgPathData] = icon;
  const dataFa = `${prefix}-${iconName}`;

  return (
    <div
      className={cn(
        ' flex items-center justify-center',
        { 'rtl:rotate-180': rtlSupport },
        className,
      )}
    >
      <svg
        viewBox={`0 0 ${iconWidth} ${iconHeight}`}
        xmlns={xmlns}
        role={'img'}
        aria-hidden="true"
        data-fa={dataFa}
        width={width}
        height={height}
        {...rest}
        fill="currentColor"
      >
        {children}
        {Array.isArray(svgPathData) ? (
          <g>
            {svgPathData.map((path, index) => (
              <path key={index} d={path} />
            ))}
          </g>
        ) : (
          <path d={svgPathData} />
        )}
      </svg>
    </div>
  );
};
